package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_01_18_Day_1
import com.veldekar.components.logs.Log_2025_01_18_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-01-18")
@Composable
public fun Log_2025_01_18(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "“Storming” the Castle",
        ogTitle = "“Storming” the Castle",
        date = LocalDate(2_025, 1, 18),
        ogDescription = "Unnatural lightning and winds do not deter the heroes from entering the Thardos family castle.",
        ogImage = "ai/2025-01-18.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-73", dateString = "Newgrowth 73")
        Log_2025_01_18_Day_1()
        SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
        Log_2025_01_18_Day_2()
    }
}
